import React from 'react';

import { Tabs, Title } from '@mantine/core';
import PageHeader from 'components/PageHeader';

import BenchmarkLibrary from './components/BenchmarkLibrary';
import MovementLibrary from './components/MovementLibrary/MovementLibrary';
import WorkoutLibrary from './components/WorkoutLibrary/WorkoutLibrary';

const Library = (): JSX.Element => {
  return (
    <>
      <PageHeader withoutBorder>
        <Title order={1}>Library</Title>
      </PageHeader>

      <Tabs
        keepMounted={false}
        defaultValue='workouts'
        variant='outline'
        styles={{
          root: { overflowY: 'auto', flexGrow: 1, display: 'flex', flexDirection: 'column' },
          tabsList: { flexGrow: 0 },
          panel: { overflowY: 'auto', flexGrow: 1, display: 'flex', flexDirection: 'column' },
        }}
      >
        <Tabs.List>
          <Tabs.Tab value='workouts'>Workouts</Tabs.Tab>
          <Tabs.Tab value='movements'>Movements</Tabs.Tab>
          <Tabs.Tab value='benchmarks'>Benchmarks</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value='workouts' pt='md'>
          <WorkoutLibrary />
        </Tabs.Panel>

        <Tabs.Panel value='movements' pt='md'>
          <MovementLibrary />
        </Tabs.Panel>

        <Tabs.Panel value='benchmarks' pt='md'>
          <BenchmarkLibrary />
        </Tabs.Panel>
      </Tabs>
    </>
  );
};

export default Library;
